export default __webpack_public_path__ + "static/media/banner_cubi.0ddaab78.svg";